"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const column_layout_1 = __importDefault(require("@amzn/awsui-components-react/polaris/column-layout"));
const polaris_1 = require("@amzn/awsui-components-react/polaris");
const node_id_input_cell_1 = require("../../common/client_inputs/node_id_input_cell");
const awsui_components_react_1 = require("@amzn/awsui-components-react");
const process_id_filter_1 = require("./process_id_filter");
const functions_1 = require("../../../common/functions");
function ProvisionInputForm(props) {
    function onInputChange(component, key, value, defaultValue) {
        const newFormData = { ...props.formData };
        if (component === 'field') {
            value ? (newFormData[key] = value.trim()) : (newFormData[key] = undefined);
        }
        else if (component === 'provision-input-group') {
            value
                ? (newFormData.provisioningInputs[`${key}`] = value.trim())
                : (newFormData.provisioningInputs[`${key}`] = undefined);
        }
        else if (component === 'provision-input-group-optional') {
            value
                ? (newFormData.provisioningInputs[`${key}`] = value.trim())
                : (newFormData.provisioningInputs[`${key}`] = defaultValue);
        }
        props.setFormData(newFormData);
    }
    function onPodIdChange(option) {
        props.setSelectedPodId(option);
        const newFormData = { ...props.formData };
        newFormData.provisioningInputs = {}; // Reset provisioning inputs in case of inconsistency between pods
        newFormData.podId = option.label;
        props.setFormData(newFormData);
        let template;
        downloadAndConvertJson(option.value)
            .then((result) => {
            template = result;
        })
            .catch((error) => {
            console.log("Couldn't get input template from file, try default template", error);
            template = (0, process_id_filter_1.getProvisionInputTemplateByProcessId)(props.processId);
        })
            .finally(() => {
            template.map((element, index) => {
                if (element.defaultValue !== '') {
                    newFormData.provisioningInputs[element.name] = element.defaultValue;
                }
            });
            props.setProvisionInputTemplate(template);
        });
    }
    return ((0, jsx_runtime_1.jsxs)(awsui_components_react_1.SpaceBetween, { size: "l", children: [(0, jsx_runtime_1.jsx)(polaris_1.FormField, { label: 'Pod ID', description: 'POD to which the device belongs', children: (0, jsx_runtime_1.jsx)(awsui_components_react_1.Select, { selectedOption: props.selectedPodId, filteringType: 'manual', options: Object.entries(props.templateUrls).map(([podId, templateUrl]) => ({
                        label: podId,
                        value: templateUrl,
                    })), onChange: ({ detail }) => {
                        onPodIdChange(detail.selectedOption);
                    }, statusType: (0, functions_1.sizeOfObject)(props.templateUrls) > 0 ? 'finished' : 'loading' }) }), (0, jsx_runtime_1.jsxs)(column_layout_1.default, { columns: 2, children: [props.isManagedEdgeCompute && (0, functions_1.sizeOfObject)(props.provisionInputTemplate) > 0 && ((0, jsx_runtime_1.jsx)(FormCell, { element: node_id_input_cell_1.node_id_input_cell, formData: props.formData, onInputChange: onInputChange }, 0)), props.provisionInputTemplate.map((element, index) => {
                        return ((0, jsx_runtime_1.jsx)(FormCell, { element: element, formData: props.formData, onInputChange: onInputChange }, props.isManagedEdgeCompute ? index + 1 : index));
                    })] })] }));
}
exports.default = ProvisionInputForm;
function FormCell(props) {
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(polaris_1.FormField, { description: props.element.description, label: props.element.label, id: props.element.name, children: (0, jsx_runtime_1.jsx)(polaris_1.Input, { onChange: (e) => props.onInputChange(props.element.component, props.element.name, e.detail.value, props.element.defaultValue), value: `${props.element.component}` === 'field'
                    ? props.formData[`${props.element.name}`] || ''
                    : props.formData.provisioningInputs[`${props.element.name}`] || '' }) }) }, props.key));
}
async function downloadAndConvertJson(url) {
    if ((0, functions_1.isEmptyString)(url)) {
        throw new Error('URL is empty');
    }
    const response = await fetch(url);
    if (!response.ok) {
        throw new Error(`Failed to download JSON file: ${response.status} ${response.statusText}`);
    }
    const json = await response.json();
    const convertedData = json; // Assuming the JSON structure matches the interface
    return convertedData;
}
